"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReEnrichAlert = void 0;
const react_1 = __importDefault(require("react"));
const re_enrich_button_1 = require("./components/re-enrich-button");
const re_enrich_alert_styles_1 = require("./re-enrich-alert.styles");
const use_history_changes_hook_1 = require("../../hooks/use-history-changes.hook");
const localization_1 = require("../../../localization");
const ReEnrichAlert = ({ className, loading, disabled, onReEnrichClick, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { selectedStrategyNodeChanges = [] } = (0, use_history_changes_hook_1.useHistoryChanges)();
    const count = selectedStrategyNodeChanges.length;
    const message = loading
        ? t({ key: 'RE_ENRICH_CATEGORY_IN_PROGRESS_NOTIFICATION_MESSAGE' })
        : t({ key: 'RE_ENRICH_CATEGORY_NOTIFICATION_MESSAGE', values: { count } });
    const actionTitle = loading
        ? t({ key: 'RE_ENRICH_CATEGORY_ACTION_IN_PROGRESS_TITLE' })
        : t({ key: 'RE_ENRICH_CATEGORY_ACTION_TITLE' });
    return (react_1.default.createElement(re_enrich_alert_styles_1.StyledReEnrichAlert, { className: className }, react_1.default.createElement("span", null, message), react_1.default.createElement(re_enrich_button_1.ReEnrichButton, { loading: loading, disabled: disabled, onClick: onReEnrichClick }, actionTitle)));
};
exports.ReEnrichAlert = ReEnrichAlert;
exports.default = exports.ReEnrichAlert;
